<template>
  <div>
    <div v-if="!loading">
      <div v-if="quotes.length > 0">
        <v-card :id="`quotes-${i}`" v-for="(quote, i) in quotes" :key="i" class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4 tw-mt-4 md:tw-mt-4">
          <div class="tw-w-full tw-flex tw-text-center md:tw-text-left">
            <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-my-5 md:tw-my-8 tw-flex-wrap">
              <div class="tw-flex tw-px-2 md:tw-px-10 tw-items-center">
                <v-icon color="primary" size="80" alt="car">mdi-car-outline</v-icon>
                <div class="tw-px-2 md:tw-px-3">
                  <h3 class="c-navy-text c-title tw-text-base md:tw-text-xl">Motor Insurance</h3>
                  <p class="c-navy-text tw-text-sm tw-mt-2 md:tw-mt-4">Request For Quotation</p>
                </div>
              </div>
              <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-6 tw-mt-5 md:tw-mt-0">
                <h3 class="c-gray-text c-title tw-text-base md:tw-text-xl">{{ quote.details.client.fullName || authenticatedUser.name }}</h3>
                <h3 class="c-blue-text c-title tw-text-base md:tw-text-xl">{{ filterCar(quote).car.make + ' '+ filterCar(quote).car.model + ', ' + filterCar(quote).car.yearOfManufacture  }} </h3>
              </div>
              <div class="tw-px-0 md:tw-px-6 tw-mt-5 md:tw-mt-0 tw-flex tw-flex-col tw-items-center">
                <h4 class="c-blue-text tw-text-sm tw-w-full"> <strong>Phone:</strong> {{ quote.details.client.mobileNumber || authenticatedUser.phone_number }}</h4>
              </div>
            </div>
          </div>
          <div class="tw-w-full tw-px-0 md:tw-px-8">
            <v-stepper alt-labels>
              <v-stepper-header>
                <v-stepper-step
                    step="1"
                    :complete="progress(quote) > 0"
                >
                  Personal Details
                </v-stepper-step>

                <v-divider :color="progress(quote) > 0 ? 'secondary' : ''"></v-divider>

                <v-stepper-step
                    step="2"
                    :complete="progress(quote) > 35"
                >
                  Vehicle Details
                </v-stepper-step>

                <v-divider :color="progress(quote) > 35 ? 'secondary' : ''"></v-divider>

                <v-stepper-step
                    step="3"
                    :complete="progress(quote) > 67"
                >
                  Cover Summary
                </v-stepper-step>

                <v-divider :color="progress(quote) > 67 ? 'secondary' : ''"></v-divider>

                <v-stepper-step
                    :complete="progress(quote) === 100"
                    step="4">
                  Make Payment
                </v-stepper-step>
              </v-stepper-header>
            </v-stepper>
          </div>
          <div class="tw-w-full tw-flex tw-justify-end tw-mt-3 md:tw-mt-6">
            <v-btn class="primary1" :id="`resume-quotes-${i}`" :to="{name: 'BuyCover', query: {q: quote.quoteId, b: filterCar(quote).riskId}}"><span class="c-white-text">Resume Quote</span><v-icon color="#fff">mdi-chevron-right</v-icon></v-btn>
          </div>
        </v-card>
      </div>
      <div v-if="healthQuotes.length > 0">
        <v-card :id="`healthQuotes-${i}`" v-for="(healthQuote, i) in healthQuotes" :key="i" class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4 tw-mt-4 md:tw-mt-4">
          <div class="tw-w-full tw-flex tw-text-center md:tw-text-left">
            <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-my-5 md:tw-my-8 tw-flex-wrap">
              <div class="tw-flex tw-px-2 md:tw-px-10 tw-items-center">
                <v-icon color="primary" size="80" alt="car">mdi-hospital-box-outline</v-icon>
                <div class="tw-px-2 md:tw-px-3">
                  <h3 class="c-navy-text c-title tw-text-base md:tw-text-xl">Medical Insurance</h3>
                  <p class="c-navy-text tw-text-sm tw-mt-2 md:tw-mt-4">Request For Quotation</p>
                </div>
              </div>
              <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-6 tw-mt-5 md:tw-mt-0">
                <h3 class="c-gray-text c-title tw-text-base md:tw-text-xl"> <strong>Inpatient Limit:</strong> {{ healthQuote.inpatient_limit }}</h3>
                <!-- <h3 class="c-blue-text c-title tw-text-base md:tw-text-xl">{{ filterCar(quote).car.make + ' '+ filterCar(quote).car.model + ', ' + filterCar(quote).car.yearOfManufacture  }} </h3> -->
              </div>
              <div class="tw-px-0 md:tw-px-6 tw-mt-5 md:tw-mt-0 tw-flex tw-flex-col tw-items-center">
                <h4 class="c-blue-text tw-text-sm tw-w-full"> <strong>Cover Premium:</strong> {{ healthQuote.cover_premium }}</h4>
              </div>
            </div>
          </div>
          <!-- <div class="tw-w-full tw-px-0 md:tw-px-8">
            <v-stepper alt-labels>
              <v-stepper-header>
                <v-stepper-step
                    step="1"
                    :complete="progress(quote) > 0"
                >
                  Personal Details
                </v-stepper-step> -->

                <!-- <v-divider :color="progress(quote) > 0 ? 'secondary' : ''"></v-divider>

                <v-stepper-step
                    step="2"
                    :complete="progress(quote) > 35"
                >
                  Vehicle Details
                </v-stepper-step>

                <v-divider :color="progress(quote) > 35 ? 'secondary' : ''"></v-divider>

                <v-stepper-step
                    step="3"
                    :complete="progress(quote) > 67"
                >
                  Cover Summary
                </v-stepper-step> -->

                <!-- <v-divider :color="progress(quote) > 67 ? 'secondary' : ''"></v-divider>

                <v-stepper-step
                    :complete="progress(quote) === 100"
                    step="4">
                  Make Payment
                </v-stepper-step>
              </v-stepper-header>
            </v-stepper> -->
          <!-- </div> -->
          <div class="tw-w-full tw-flex tw-justify-end tw-mt-3 md:tw-mt-6">
            <!-- <v-btn class="primary1" :id="`resume-quotes-${i}`" :to="{name: 'BuyCover', query: {q: quote.quoteId, b: filterCar(quote).riskId}}"><span class="c-white-text">Resume Quote</span><v-icon color="#fff">mdi-chevron-right</v-icon></v-btn> -->
            <v-btn class="primary1" :id="`resume-healthQuotes-${i}`" :to="{name: 'BuyCover', query: {q: healthQuote.id, b: 'health'}}"><span class="c-white-text">Resume Quote</span><v-icon color="#fff">mdi-chevron-right</v-icon></v-btn>
          </div>
        </v-card>
      </div>
      <div v-if="dpQuotes.length > 0">
        <v-card :id="`dpQuotes-${i}`" v-for="(dpQuote, i) in dpQuotes" :key="i" class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4 tw-mt-4 md:tw-mt-4">
          <div class="tw-w-full tw-flex tw-text-center md:tw-text-left">
            <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-my-5 md:tw-my-8 tw-flex-wrap">
              <div class="tw-flex tw-px-2 md:tw-px-10 tw-items-center">
                <v-icon color="primary" size="80" alt="car">mdi-home-circle-outline</v-icon>
                <div class="tw-px-2 md:tw-px-3">
                  <h3 class="c-navy-text c-title tw-text-base md:tw-text-xl">Domestic Package</h3>
                  <p class="c-navy-text tw-text-sm tw-mt-2 md:tw-mt-4">Request For Quotation</p>
                </div>
              </div>
              <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-6 tw-mt-5 md:tw-mt-0">
                <h3 class="c-gray-text c-title tw-text-base md:tw-text-xl"> <strong>Home Option:</strong> {{ dpQuote.home_option }}</h3>
                <!-- <h3 class="c-blue-text c-title tw-text-base md:tw-text-xl">{{ filterCar(quote).car.make + ' '+ filterCar(quote).car.model + ', ' + filterCar(quote).car.yearOfManufacture  }} </h3> -->
              </div>
              <div class="tw-px-0 md:tw-px-6 tw-mt-5 md:tw-mt-0 tw-flex tw-flex-col tw-items-center">
                <h4 class="c-blue-text tw-text-sm tw-w-full"> <strong>Cover Premium:</strong> {{ dpQuote.premium }}</h4>
              </div>
            </div>
          </div>
          <!-- <div class="tw-w-full tw-px-0 md:tw-px-8">
            <v-stepper alt-labels>
              <v-stepper-header>
                <v-stepper-step
                    step="1"
                    :complete="progress(quote) > 0"
                >
                  Personal Details
                </v-stepper-step> -->

                <!-- <v-divider :color="progress(quote) > 0 ? 'secondary' : ''"></v-divider>

                <v-stepper-step
                    step="2"
                    :complete="progress(quote) > 35"
                >
                  Vehicle Details
                </v-stepper-step>

                <v-divider :color="progress(quote) > 35 ? 'secondary' : ''"></v-divider>

                <v-stepper-step
                    step="3"
                    :complete="progress(quote) > 67"
                >
                  Cover Summary
                </v-stepper-step> -->

                <!-- <v-divider :color="progress(quote) > 67 ? 'secondary' : ''"></v-divider>

                <v-stepper-step
                    :complete="progress(quote) === 100"
                    step="4">
                  Make Payment
                </v-stepper-step>
              </v-stepper-header>
            </v-stepper> -->
          <!-- </div> -->
          <div class="tw-w-full tw-flex tw-justify-end tw-mt-3 md:tw-mt-6">
            <!-- <v-btn class="primary1" :id="`resume-quotes-${i}`" :to="{name: 'BuyCover', query: {q: quote.quoteId, b: filterCar(quote).riskId}}"><span class="c-white-text">Resume Quote</span><v-icon color="#fff">mdi-chevron-right</v-icon></v-btn> -->
            <v-btn class="primary1" :id="`resume-dpQuotes-${i}`" :to="{name: 'BuyCover', query: {q: dpQuote.id, b: 'dp'}}"><span class="c-white-text">Resume Quote</span><v-icon color="#fff">mdi-chevron-right</v-icon></v-btn>
          </div>
        </v-card>
      </div>
      <div v-if="quotes.length==0 && healthQuotes.length==0 && dpQuotes.length==0" class="tw-w-full tw-mt-5 md:tw-mt-10">
        <v-card class="tw-w-full tw-flex tw-flex-wrap tw-text-center tw-justify-center tw-py-24">
          <div class="tw-w-full tw-flex tw-justify-center">
            <v-icon size="70" color="gray">mdi-file</v-icon>
          </div>
          <p class="tw-text-2xl tw-mt-6 c-gray-text">No recent quotes available</p>
        </v-card>
      </div>
    </div>
    <div v-else class="tw-w-full tw-flex tw-justify-center">
      <v-progress-circular
          :size="80"
          color="primary1"
          indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';

export default {
  name: 'Quotes',
  data() {
    return {
      quotes: [],
      healthQuotes: [],
      dpQuotes: [],
      loading: true,
      page: 0,
    };
  },
  computed: {
    ...mapGetters('auth', ['authenticatedUser']),
  },
  async mounted() {
    await this.getMotorQuotes(`/customer/quotation/clientQuotes/${this.authenticatedUser['custom:kra-pin']}?renewal=false&page=1&size=2`);
    await this.getHealthQuotes(`/customer/digital-quotation/pacis-amani/quotes?email_address=${this.authenticatedUser.email}`);
    await this.getDPQuotes(`/customer/digital-quotation/domestic-package/quotes?email_address=${this.authenticatedUser.email}`);
    this.$emit('saved-quotes-loaded', this.quotes && this.healthQuotes && this.dpQuotes);
  },
  methods: {
    async getMotorQuotes(url) {
      await axios.get(url)
        .then((response) => {
          if (response.data.success) {
            this.quotes = response.data.data;
            this.page += 1;
          }
          this.loading = false;
        });
    },
    async getHealthQuotes(url) {
      await axios.get(url)
        .then((response) => {
          this.healthQuotes = response.data;
          this.page += 1;
          this.loading = false;
        });
    },
    async getDPQuotes(url) {
      await axios.get(url)
        .then((response) => {
          this.dpQuotes = response.data;
          this.page += 1;
          this.loading = false;
        });
    },
    filterCar(quote) {
      return quote.details.risks.find((s) => s.selected === 'Y') || quote.details.risks[0];
    },
    progress(quote) {
      const risk = this.filterCar(quote);
      let step = 0;
      if (quote.step === 'POLICY_PAYMENT') {
        step = 100;
      } else if ('mainBranchCode' in quote && quote.mainBranchCode !== '') {
        step = 80;
      } else if ('engineNo' in risk.car && risk.car.engineNo !== '') {
        step = 66.66;
      } else if ('coverFrom' in quote && quote.coverFrom !== '') {
        step = 33.33;
      }
      return step;
    },
  },
};
</script>
<style lang="scss" scoped>
.v-stepper {
  box-shadow: none!important;
}
</style>
